import React from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';
import DocumentHitsFormat from '@Components/Results/services/document-hits-format.service';

function DocumentAbstractHitComponent({ abstractText, closeClick, trackingAttrs }) {
  const abstractHit = DocumentHitsFormat.checkAndFormatHit(abstractText, 'abstract');

  return abstractHit ? (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    <div
      className="result-detail-panel result-detail-abstract-hit document-hit e2e-document-action-abstract-hit"
      onClick={closeClick}
      role="button"
      tabIndex="0"
      {...trackingAttrs}>
      <div className="result-detail-panel-wrapper">
        <h4>Abstract hit:</h4>
        <InnerHTML tag="div" className="result-detail-block typography-small" html={abstractHit} />
        <svg className="els-btn-icon svg-icon els-btn-icon-sm">
          <use xlinkHref="#icon-chevron-down" />
        </svg>
      </div>
    </div>
  ) : null;
}

DocumentAbstractHitComponent.propTypes = {
  abstractText: PropTypes.string.isRequired,
  closeClick: PropTypes.func.isRequired,
  trackingAttrs: PropTypes.object.isRequired,
};

export default DocumentAbstractHitComponent;
